import Gikam from '../../../core/gikam-core';

const columns = [
    {
        title: '列名称',
        field: 'title',
        width: 150,
    }, {
        title: '列排序',
        type: 'drag',
        width: 100,
    }, {
        title: '是否显示',
        field: 'visible',
        width: 100,
        type: 'simpleCheckbox',
        editor: true
    }, {
        title: '冻结',
        field: 'fixed',
        width: 100,
        type: 'simpleCheckbox',
        editor: true
    }];

export default class GridConfig {
    constructor(store) {
        this.store = store;
        this.init();
    }

    initModal() {
        // const _this = this;
        const result = Gikam.createSimpleModal({
            title: '表格配置',
            width: 600,
            height: 400,
            // toolbarFormatter(toolbar) {
            //     toolbar.unshift({
            //         type: 'button',
            //         text: "恢复默认",
            //         onClick() {
            //             _this.revertDefault();
            //         }
            //     });
            //     return toolbar;
            // },
            onConfirm: () => this.confirm(),
            onCancel: () => this.cancel()
        });
        this.modal = result.modal;
        this.layout = result.layout;
    }

    revertDefault() {
        const defaultColumns = this.grid.options.columns.map(item => {
            return Gikam.extend(item, {
                fixed: item.fixed == true ? '1' : '0',
                visible: item.visible === '0' ? '0' : '1',
                title: Gikam.propI18N(item.title)
            })
        });
        this.modal.window.showMask();
        this.updateColumns(defaultColumns).done(() => {
            this.store.commit('refreshColumns', defaultColumns);
            this.modal.close();
        }).always(() => this.modal.window.closeMask());
    }

    confirm() {
        const newColumns = this.grid.getData();
        const finalColumns = this.store.state.columns.filter(item => {
            return item.checkbox || item.radio || item.index;
        }).concat(newColumns);
        this.modal.window.showMask();
        this.updateColumns(newColumns).done(() => {
            this.store.commit('refreshColumns', finalColumns);
            this.modal.close();
        }).always(() => this.modal.window.closeMask());
    }

    updateColumns(newColumns) {
        const url = Gikam.IFM_CONTEXT + '/core/module/sys/page-grid-field-configs';
        const { gridId, $window } = this.store.state;
        return Gikam.postText(url, Gikam.getJsonWrapper({ gridId, pageId: $window.$pageId }, ['', newColumns]))
    }

    cancel() {
        this.modal.close();
    }

    getGridData() {
        return Gikam.deepExtend(this.store.state.columns).filter(item => {
            return item.field;
        }).map(item => {
            return Gikam.extend(item, {
                fixed: item.fixed == true ? '1' : '0',
                visible: item.visible === '0' ? '0' : '1',
                title: Gikam.propI18N(item.title)
            });
        });
    }

    initGrid() {
        this.grid = Gikam.create('grid', {
            renderTo: this.layout.options.center.$dom,
            page: false,
            fill: true,
            filter: false,
            autoSave: false,
            editorInvisible: true,
            generalButtonGroup: false,
            columns: columns,
            data: this.getGridData()
        });
    }

    init() {
        this.initModal();
        this.initGrid();
    }
}

